document.addEventListener('DOMContentLoaded', function () {
  const variantSelects = document.querySelector('variant-selects');
  const wrapper = document.getElementById('variant-ingredients-container');

  if (!variantSelects || !wrapper) return;

  const allWrappers = wrapper.querySelectorAll('.ingredients-wrapper');

  function updateVariantMetaobjectDisplay(selectedVariant) {
   allWrappers.forEach(div => {
    const variantId = div.dataset.variantId;
    const isActive = variantId == selectedVariant.id;

    div.style.display = isActive ? 'block' : 'none';

    if (isActive) {
      requestAnimationFrame(() => {
        const flickityEl = div.querySelector('.flickity-enabled, .flickity-slider');

        if (flickityEl) {
          const flktyInstance = Flickity.data(flickityEl);

          if (flktyInstance) {
            flktyInstance.resize();
          } else {
            new Flickity(flickityEl, {
              cellAlign: 'left',
              contain: true,
              wrapAround: true
            });
          }
        }
      });
    }
  });
  }

  const variantScript = variantSelects.querySelector('script[type="application/json"]');
  const variants = variantScript ? JSON.parse(variantScript.textContent) : [];

  const radios = variantSelects.querySelectorAll('input[type="radio"]');
  radios.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const selectedVariant = variants.find(v => v.option1 === this.value);
        if (selectedVariant) {
          updateVariantMetaobjectDisplay(selectedVariant);
        }
      }
    });
  });

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      updateVariantMetaobjectDisplay(event.detail.variant);
    }
  });

  const defaultVariantId = wrapper.querySelector('.ingredients-wrapper')?.dataset.variantId;
  if (defaultVariantId) {
    const defaultVariant = variants.find(v => v.id == defaultVariantId);
    if (defaultVariant) {
      updateVariantMetaobjectDisplay(defaultVariant);
    }
  }
});
